<template>
    <div class="data-entry-note-view">
        <div :title="updatedDate">{{ createdDate }}</div>
        <div>{{ note.user.firstName }} {{ note.user.lastName }}</div>
        <div>
            <i @click="edit" class="material-icons" v-if="editable">edit</i>
            <i @click="destroy" class="material-icons" style="color: red" v-if="editable">delete</i>
        </div>
        <div>
            <span v-for="(line, index) in displayLines" :key="index">{{ line }}<br /></span>
        </div>
    </div>
</template>
<script>
import { jwt } from '@/utils/jwt.js'

export default {
    props: {
        note: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            deleting: false,
        }
    },
    computed: {
        createdDate() {
            return new Date(this.note.createdDate).toLocaleString()
        },
        displayLines() {
            return this.note.noteText.split('\n')
        },
        editable() {
            return jwt.id === this.note.user?.id
        },
        updatedDate() {
            return `Updated ${new Date(this.note.updatedDate).toLocaleString()}`
        },
    },
    methods: {
        destroy() {
            this.$emit('destroy', this.note)
        },
        edit() {
            this.$emit('edit', this.note)
        },
    },
}
</script>
<style>
.data-entry-note-view {
    display: flex;
    flex-wrap: wrap;

    > div {
        padding: 8px 16px;

        &:nth-child(1) {
            width: 200px;
        }

        &:nth-child(2) {
            flex-grow: 1;
            text-align: right;
        }

        &:nth-child(3) {
            width: 64px;
        }

        &:nth-child(4) {
            width: 100%;
        }
    }

    .material-icons {
        cursor: pointer;
        font-size: 16px;
    }
}
</style>
